import React from 'react';
import './App.css';
import Login from "./Login";
import Header from './Header';
import SideBar from './SideBar';
import Feed from './Feed';
import Widgets from "./Widgets";
import {useStateValue} from "./StateProvider";


function App() {
const [{user},dispatch] = useStateValue("");

  return (
    //BEM naming convention
    <div className="App">

          <>
  <Header/>


  <div className="app__body" >
    <SideBar/>
    <Feed/>
    <Widgets />
    </div>
</>
 )

        
    </div>
  );
}

export default App;
